import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';
import RoleInput from '../../shared/input/RoleInput';

const UserUpdateForm = ({ onSubmit, user, loading, roles }) => {
  const methods = useForm({ defaultValues: user });
  return (
    <FormProvider {...methods}>
      <form id="user-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Ім'я"
          type="input"
          name="firstName"
          autoFocus="true"
          disabled={loading}
          placeholder={"Введіть ім'я"}
          validation={notBlankValidation}
        />
        <Input
          label="Прізвище"
          type="input"
          name="lastName"
          disabled={loading}
          placeholder={'Введіть прізвище'}
          validation={notBlankValidation}
        />
        <RoleInput roles={roles} loading={loading} />
      </form>
    </FormProvider>
  );
};

export default UserUpdateForm;
